import { useDriverForm } from '@/modules/drivers/context/DriverFormContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { DateField } from '@/ui/form/controls/DateField'
import { TextField } from '@/ui/form/controls/TextField'
import { Switch } from '@/ui/form/primitives/Switch'
import * as React from 'react'
import { parsePesel } from '../full/DriverDataStage'

const DriverDataStage = () => {
  const { t } = useLocalize()
  const { isActive, setIsActive, data, setData } = useDriverForm()
  const handlePeselChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const pesel = e.target.value
    setData({ ...data, pesel })

    if (pesel.length === 11) {
      const parsed = parsePesel(pesel)
      if (parsed) {
        setData({
          ...data,
          pesel,
          sex: parsed.sex,
          ...(parsed.birthday ? { birthday: parsed.birthday } : {}),
        })
      }
    }
  }
  return (
    <div className="tw-flex tw-justify-between">
      <div className="tw-w-full tw-max-w-[256px]">
        <p className="tw-text-lg tw-font-semibold tw-text-content-base">
          {t('driverBasics.driver-data')}
        </p>
      </div>
      <div className="tw-flex tw-flex-1 tw-flex-col tw-gap-4">
        <TextField
          label={t('driverBasics.first-name')}
          required
          placeholder={t('common.type')}
          value={data?.name}
          onChange={(e) => setData({ ...data, name: e.target.value })}
        />
        <TextField
          label={t('driverBasics.last-name')}
          required
          placeholder={t('common.type')}
          value={data?.surname}
          onChange={(e) => setData({ ...data, surname: e.target.value })}
        />
        <TextField
          label={t('driverBasics.pesel')}
          required
          placeholder={t('common.type')}
          value={data?.pesel || data?.driverId?.value || ''}
          // onChange={(e) => setData({ ...data, pesel: e.target.value })}
          onChange={handlePeselChange}
        />
        <DateField
          label={t('driverBasics.work-start-date')}
          value={data?.workingStartTime}
          setValue={(e) => setData({ ...data, workingStartTime: e })}
        />
        <div className="tw-h-[1px] tw-w-full tw-bg-base-300"></div>
        <div className="tw-flex tw-items-center tw-justify-between">
          <p className="tw-text-sm tw-font-medium tw-text-content-base">
            {t('common.active')}
          </p>
          <Switch
            checked={isActive}
            onChange={(e) => setIsActive(e.target.checked)}
          />
        </div>
      </div>
    </div>
  )
}

export default DriverDataStage
